module.exports = __webpack_public_path__ + "img/c03_unitchampion_Normal_ua.e4f175e3.webp";